import { apiGetUserNotificationList } from '@/dashboard/api/settings';
import { RequestCommonParams } from '@jove-frontend/uikit';
import { enableMapSet } from 'immer';
import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

interface SettingsState {
  menuListActiveItem: string;
  unReadNotificationList: any[];
}

interface SettingsActions {
  updateMenuListActiveItem: (item: string) => void;
  updateUnReadNotificationList: (params?: RequestCommonParams) => Promise<void>;
}

interface SettingsStore {
  state: SettingsState;
  actions: SettingsActions;
}

enableMapSet();

export const useSettingsStore = create<SettingsStore>()(
  immer((set, get) => ({
    state: {
      menuListActiveItem: '',
      unReadNotificationList: [],
    },
    actions: {
      // update select menu item
      updateMenuListActiveItem: (item: string) => {
        set((store) => {
          store.state.menuListActiveItem = item;
        });
      },
      // update select menu item
      updateUnReadNotificationList: async () => {
        const [res] = await apiGetUserNotificationList({ read: false, hideErrToast: true });

        if (res) {
          set((store) => {
            store.state.unReadNotificationList = res.data;
          });
        }
      },
    },
  }))
);
